import type { ReactNode } from 'react';
import type { MapStateToPropsFactory } from 'react-redux';
import { connect } from 'react-redux';
import { secondaryMarketCpOrderFormFieldChanged } from 'state/secondaryMarket/cpOrder';
import type { SecondaryMarketCpOrderForm } from 'state/secondaryMarket/cpOrder/cpOrderForm/input/cpOrderInputForm.model';
import type { SecondaryMarketFormError } from 'state/secondaryMarket/shared/form/validationResults';
import type { KycDetail, KycScoreStatus } from 'state/secondaryMarket/shared/kyc/kyc.model';
import { fromSecondaryMarket } from 'state/selectors';
import type { ThunkDispatch } from 'state/state.common';
import type { AppState } from 'state/state.model';

type OwnProps = Readonly<{
  tabId: string;
  className?: string;
  children: ReactNode;
}>;

type StateProps = Readonly<{
  validationErrors: readonly SecondaryMarketFormError<SecondaryMarketCpOrderForm>[];
  backendReports: readonly SecondaryMarketFormError<SecondaryMarketCpOrderForm>[];
  comment: string | undefined;
  kycScore: KycScoreStatus | undefined;
  kycDetails: readonly KycDetail[] | undefined;
}>;
type DispatchProps = Readonly<{
  onCommentChanged: (value: string) => void;
}>;

export type NotReadySidePanelProps = OwnProps & StateProps & DispatchProps;

const mapStateToProps: MapStateToPropsFactory<StateProps, OwnProps, AppState> = () => {
  const getCpOrderValidationErrors = fromSecondaryMarket.cpOrder.form.makeGetCpOrderValidationErrors();
  const getBackendReports = fromSecondaryMarket.cpOrder.form.makeGetBackendReports();
  return (state: AppState, { tabId }: OwnProps): StateProps => {
    const formErrors = getCpOrderValidationErrors(state, tabId);
    const comment = fromSecondaryMarket.cpOrder.form.getFormComment(state, tabId);
    const kycScore = fromSecondaryMarket.cpOrder.referential.kyc.getKycStatusScore(state, tabId);
    const kycDetails = fromSecondaryMarket.cpOrder.referential.kyc.getKycStatusDetails(state, tabId);
    const backendReports = getBackendReports(state, tabId);
    return {
      validationErrors: formErrors,
      comment,
      kycScore,
      kycDetails,
      backendReports,
    };
  };
};

const mapDispatchToProps = (dispatch: ThunkDispatch, { tabId }: OwnProps): DispatchProps => {
  return {
    onCommentChanged: value => {
      dispatch(secondaryMarketCpOrderFormFieldChanged(tabId, 'comment', value));
    },
  };
};

export const connectNotReadySidePanel = connect(mapStateToProps, mapDispatchToProps);
